import { render, staticRenderFns } from "./MtrlEditAbout.vue?vue&type=template&id=33f9e669&scoped=true&"
import script from "./MtrlEditAbout.vue?vue&type=script&lang=js&"
export * from "./MtrlEditAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f9e669",
  null
  
)

export default component.exports